/**
 * OAuth Email Connection API Service (KAN-60)
 */

import { apiClient, APIResponse } from './client';
import type {
  OAuthAuthorizeResponse,
  EmailConnectionStatus,
  ConnectionTestResult,
  EmailSendingConfig,
} from '../../types/oauth';

class OAuthService {
  async authoriseMicrosoft(): Promise<APIResponse<OAuthAuthorizeResponse>> {
    return apiClient.post<OAuthAuthorizeResponse>('/api/v1/oauth/microsoft/authorize');
  }

  async disconnect(): Promise<APIResponse<void>> {
    return apiClient.post<void>('/api/v1/oauth/disconnect');
  }

  async testConnection(): Promise<APIResponse<ConnectionTestResult>> {
    return apiClient.post<ConnectionTestResult>('/api/v1/oauth/test-connection');
  }

  async getStatus(): Promise<APIResponse<EmailConnectionStatus>> {
    return apiClient.get<EmailConnectionStatus>('/api/v1/oauth/status');
  }

  async updateConfig(config: EmailSendingConfig): Promise<APIResponse<void>> {
    return apiClient.put<void>('/api/v1/oauth/config', config);
  }
}

export const oauthService = new OAuthService();
